import {uuid} from 'uuidv4';
import RackUtils from "effects/rack/RackUtils.js";
import {setPads, setPadSlots} from 'actions/index.js';
import Dispatchable from "utils/Dispatchable.js";
import Racked from './Racked.js';
const NUM_SLOTS = 9;

class Pad extends Racked(RackUtils(Dispatchable(class {}))) {
    constructor(subSequence, createRack=true) {
        super();
        this.subSequence = subSequence;
        this.sequencerEngine = subSequence.sequencerEngine;
        this.id = uuid();
        this.tracks = new Array(NUM_SLOTS).fill(false);
        if (createRack) {
            this.createEffectRack();
        }
    }

    get slots() {
        return this.tracks;
    }

    containsSample(sample) {
        return this.tracks.find(
            x => x && x.sample === sample);
    }
    
    switch(a,b) {
        let tmpA = this.tracks[a];
        let tmpB = this.tracks[b];
        this.tracks[a] = tmpB;
        this.tracks[b] = tmpA;
        this.updateRedux();
    }


    removeTrack(track) {
        for (let i in this.tracks) {
            if (this.tracks[i] === track) {
                this.tracks[i] = false;
            }
        }
        track.pad = undefined;
        this.updateRedux();
        this.onTrackRemoved(track);
    }

    get slotTracks() {
        return this.tracks.filter(x => x);
    }

    get patternLength() {
        return Math.max(
            ... this.slotTracks.filter(
                x => x.pattern)
                .map(x => x.pattern.length()));
    }

    addTrack(track, slotNumber, newTrack=false) {
        if (!track) {
            return;
        }
        if (this.slots[slotNumber]) {
            // theres already a track here so we remove that track
            // from the pad
            this.deleteTrack(this.slots[slotNumber]);
        }
        let tracks = [... this.tracks];
        tracks[slotNumber] = track;
        this.tracks = tracks;
        if (newTrack) {
            track.pattern.changeLength(this.patternLength);
        }
        if (track.pad) {
            // already has a pad then we need remove the track from there
            track.pad.removeTrack(track);
        }
        track.pad = this;
        this.updateRedux();
        this.onTrackAdded(track);
    }

    async newSample(sample, slotNumber) {
        let track = await this.sequencerEngine.addSound(
            sample, undefined, undefined, undefined, undefined, undefined, false);
        this.addTrack(track, slotNumber);
        return track;
    }

    updateRedux() {
        this.tracks = [... this.tracks];
        this.dispatch(setPadSlots(
            this.id, this.tracks));
    }

    deleteTrack(track) {
        let indexOf = this.slots.indexOf(track);
        if (indexOf === -1) {
            return;
        }
        this.slots[indexOf] = false;
        track.pad = false;
        this.updateRedux();
    }

    getJson() {
        return {
            id: this.id,
            tracks: this.tracks.map(x => x === false ? x : x.trackNumber),
            x: this.x,
            y: this.y,
            fxMacroValue: this.fxMacro.macroParameter.get(true),
            fxMacro: this.fxMacro.macroParameter.getJson(),
        };
    }

    getAllParameters() {
        if (!this.fxMacro || !this.effectRack) {
            return [];
        }
        return [
            this.fxMacro.macroParameter,
            ... this.effectRack.getParameters()
        ];
    }

    getJsonForPack() {
        let content = [];
        for (let slot of this.tracks) {
            if (!slot) {
                content.push(false);
            } else {
                if (slot.sample) {
                    content.push({
                        type: "SAMPLE",
                        contentHash: slot.sample.getId(),
                        preset: this.sequencerEngine.getTrackPreset(
                            slot.trackNumber)
                    });
                } else if (slot.preset && slot.preset.contentHash) {
                    content.push({
                        type: "PRESET",
                        contentHash: slot.preset.contentHash,
                        preset: this.sequencerEngine.getTrackPreset(
                            slot.trackNumber)
                    });
                } else {
                    content.push(false);
                }
            }
        }
        return content;
    }

    fromJson(json) {
        if (json.id) {
            this.id = json.id;
        }
        let i=0;
        let array = [];
        if (Array.isArray(json)) {
            array = json;
        } else {
            array = json.tracks;
            this.x = json.x;
            this.y = json.y;
        }

        if (json.fxMacroValue === undefined) {
            // legacy shit (we hadn't created effect racks yet)
            this.createEffectRack();
        } else {
            this.linkEffectRackContext();
        }

        for (let trackNumber of array) {
            if (trackNumber !== false) {
                let track = this.subSequence.tracks[parseFloat(trackNumber)];
                this.addTrack(track, i);
            }
            i++;
        }
        this.fxMacroValue = json.fxMacroValue;
        this.fxMacroJson = json.fxMacro;
    }

    deletePad() {
        this.subSequence.deletePad(this);
    }
}


export default Pad;
